export function getUser() {
  try {
    const user = localStorage.getItem('vehicle.user');
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
}

export function setUser(user) {
  try {
    localStorage.setItem('vehicle.user', JSON.stringify(user));
  } catch {}
}

export function removeUser() {
  try {
    localStorage.removeItem('vehicle.user');
    localStorage.removeItem('vehicle.token');
  } catch {}
}

export function getToken() {
  try {
    return localStorage.getItem('vehicle.token');
  } catch {
    return null;
  }
}

export function setToken(token) {
  try {
    localStorage.setItem('vehicle.token', token);
  } catch {}
}

export function getCountryFlag(countryCode) {
  if (!countryCode || countryCode.length !== 2) {
    return '🌐'; // Globe emoji as fallback
  }

  // Convert country code to flag emoji using Regional Indicator Symbols
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 0x1F1E6 + char.charCodeAt(0) - 65);

  return String.fromCodePoint(...codePoints);
}
